import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import type { IAuthLoginFormValues, IAuthLoginModel, IAuthLoginSubmitResult } from '@/types/security/auth-login';

const AUTH_LOGIN_ENDPOINT = '/api/register/auth-login';

const defaultAuthLoginModel: IAuthLoginModel = {
    languageData: {},
};

interface IAuthLoginResults {
    token: string;
}

export const useAuthLogin = () => {
    const url = AUTH_LOGIN_ENDPOINT;

    const { model, isLoading, error } = useApiModel(url, defaultAuthLoginModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<IAuthLoginFormValues, IAuthLoginResults, IAuthLoginSubmitResult>(
        url,
        (values) => {
            const isMobile = values.isMobile === '1';

            return {
                isMobile,
                email: isMobile ? '' : values.email,
                mobileNumber: isMobile ? values.mobileNumber : '',
            };
        },
        (results) => ({ token: results.token }),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
